import { TableBaseCols } from '@ge/feat-reporting/components/widgets/table-widget/table-base-cols';

// All available columns and groups for completed work
export const CompletedWorkColumns = {
  GROUP_SELECTED: TableBaseCols.GROUP_SELECTED,
  SELECTED: TableBaseCols.SELECTED,

  // Asset Details
  GROUP_ASSET_DETAILS: 'Asset Details',
  ASSET_NAME: 'Asset Name',
  ASSET_SITE: 'Site',
  ASSET_STATE: 'State',

  // Task Details
  GROUP_TASK_DETAILS: 'Task Details',
  TASK_PRIORITY: 'Priority',
  TASK_STATUS: 'Task Status',
  TASK_TITLE: 'Task Title',
  TASK_DESCRIPTION: 'Description',
  TASK_TYPE: 'Task Type',
  TASK_LINKED: 'Linked',
  TASK_COMPONENT: 'Component',
  TASK_ASSIGNED_TECHS: 'Assigned Techs',
  TASK_SR_NUMBER: 'SR Number',
  TASK_SR_STATUS: 'SR Status',
  STATUS: 'Status',
  TASK_RDSPP: 'RDSPP',

  // Estimates
  GROUP_ESTIMATES: 'Estimates',
  ESTIMATES_NUM_TECHS: 'Est # of Techs',
  ESTIMATES_DURATION: 'Est Duration',
  ESTIMATES_LABOR_HOURS: 'Est Labor Hrs',

  // Dates
  GROUP_DATES: 'Dates',
  DATES_CREATED: 'Created',
  DATES_ELIGIBLE_START: 'Eligible Start',
  DATES_SCHEDULED: 'Scheduled',
  DATES_DUE: 'Due',
  DATES_COMPLETED: 'Completed',
  SCHEDULED_END_DATE: 'Scheduled End Date',

  // Parts
  GROUP_PARTS: 'Parts',
  PARTS_EXPECTED: 'Expected',
  PARTS_CONSUMED: 'Consumed',

  // Notes
  GROUP_NOTES: TableBaseCols.GROUP_NOTES,
  NOTES_LATEST_NOTE: TableBaseCols.NOTES_LATEST_NOTE,
  NOTES_RESOLUTION: 'Resolution',
  NOTES_EXTERNAL: TableBaseCols.NOTES_EXTERNAL,
  NOTES_INTERNAL: TableBaseCols.NOTES_INTERNAL,
  NOTES_BOTH: 'Both',
};

// Completed work table configuration
export const completedWorkColumnDefs = {
  [CompletedWorkColumns.GROUP_SELECTED]: {
    fixedLeft: true,
    width: '50px',
    cols: {
      [CompletedWorkColumns.SELECTED]: {
        fixedLeft: true,
        locked: true,
        labels: [
          {
            a11yKey: 'completed_work.columns.include',
            a11yDefault: 'Include',
          },
        ],
        cell: {
          align: 'center',
          width: '50px',
        },
      },
    },
  },
  [CompletedWorkColumns.GROUP_ASSET_DETAILS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'completed_work.columns.asset_details',
        a11yDefault: 'Asset Details',
      },
    ],
    cols: {
      [CompletedWorkColumns.ASSET_NAME]: {
        locked: true,
        cell: {
          width: '50px',
        },
        labels: [
          {
            a11yKey: 'completed_work.columns.asset_name',
            a11yDefault: 'Asset',
          },
        ],
      },
      [CompletedWorkColumns.ASSET_SITE]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.site',
            a11yDefault: 'Site',
          },
        ],
      },
      [CompletedWorkColumns.ASSET_STATE]: {
        align: 'center',
        cell: {
          width: '50px',
        },
        labels: [
          {
            a11yKey: 'completed_work.columns.state',
            a11yDefault: 'State',
          },
        ],
      },
    },
  },
  [CompletedWorkColumns.GROUP_TASK_DETAILS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'completed_work.columns.task_details',
        a11yDefault: 'Task Details',
      },
    ],
    cols: {
      [CompletedWorkColumns.TASK_PRIORITY]: {
        cell: {
          width: '100px',
        },
        labels: [
          {
            a11yKey: 'completed_work.columns.priority',
            a11yDefault: 'Task Priority',
          },
        ],
      },
      [CompletedWorkColumns.TASK_STATUS]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.status',
            a11yDefault: 'Task Status',
          },
        ],
      },
      [CompletedWorkColumns.TASK_TITLE]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.task_title',
            a11yDefault: 'Task Title',
          },
        ],
      },
      [CompletedWorkColumns.TASK_DESCRIPTION]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.description',
            a11yDefault: 'Task Description',
          },
        ],
      },
      [CompletedWorkColumns.TASK_TYPE]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.task_type',
            a11yDefault: 'Task Type',
          },
        ],
      },
      [CompletedWorkColumns.TASK_LINKED]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.task_linked',
            a11yDefault: 'Linked',
          },
        ],
      },
      [CompletedWorkColumns.TASK_COMPONENT]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.component',
            a11yDefault: 'Component',
          },
        ],
      },
      [CompletedWorkColumns.TASK_ASSIGNED_TECHS]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.assigned_techs',
            a11yDefault: 'Assigned Techs',
          },
        ],
      },
      [CompletedWorkColumns.TASK_SR_NUMBER]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.sr_number',
            a11yDefault: 'SR Number',
          },
        ],
      },
      [CompletedWorkColumns.TASK_SR_STATUS]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.sr_status',
            a11yDefault: 'SR Status',
          },
        ],
      },
    },
  },
  [CompletedWorkColumns.GROUP_ESTIMATES]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'completed_work.columns.estimates',
        a11yDefault: 'Estimates',
      },
    ],
    cols: {
      [CompletedWorkColumns.ESTIMATES_NUM_TECHS]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.est_num_techs',
            a11yDefault: 'Est. # Techs',
          },
        ],
      },
      [CompletedWorkColumns.ESTIMATES_DURATION]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.est_duration',
            a11yDefault: 'Est. Duration',
          },
        ],
      },
      [CompletedWorkColumns.ESTIMATES_LABOR_HOURS]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.est_labor_hours',
            a11yDefault: 'Est. Labor Hrs',
          },
        ],
      },
    },
  },
  [CompletedWorkColumns.GROUP_DATES]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'completed_work.columns.dates',
        a11yDefault: 'Dates',
      },
    ],
    cols: {
      [CompletedWorkColumns.DATES_CREATED]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.created',
            a11yDefault: 'Created',
          },
        ],
      },
      [CompletedWorkColumns.DATES_ELIGIBLE_START]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.eligible_start',
            a11yDefault: 'Eligible Start',
          },
        ],
      },
      [CompletedWorkColumns.DATES_SCHEDULED]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.scheduled',
            a11yDefault: 'Scheduled',
          },
        ],
      },
      [CompletedWorkColumns.DATES_DUE]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.due',
            a11yDefault: 'Due',
          },
        ],
      },
      [CompletedWorkColumns.DATES_COMPLETED]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.completed',
            a11yDefault: 'Completed',
          },
        ],
      },
      [CompletedWorkColumns.SCHEDULED_END_DATE]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.scheduled_end_date',
            a11yDefault: 'Scheduled End Date',
          },
        ],
      },
    },
  },
  [CompletedWorkColumns.GROUP_PARTS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'completed_work.columns.parts',
        a11yDefault: 'Parts',
      },
    ],
    cols: {
      [CompletedWorkColumns.PARTS_EXPECTED]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.expected',
            a11yDefault: 'Expected',
          },
        ],
      }, // TODO: Header alignment customization to include quantity
      [CompletedWorkColumns.PARTS_CONSUMED]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.consumed',
            a11yDefault: 'Consumed',
          },
        ],
      }, // TODO: Header alignment customization to include quantity
    },
  },
  [CompletedWorkColumns.GROUP_NOTES]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'completed_work.columns.notes',
        a11yDefault: 'Notes',
      },
    ],
    cols: {
      [CompletedWorkColumns.NOTES_LATEST_NOTE]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.latest_note',
            a11yDefault: 'Latest Note',
          },
        ],
      },
      [CompletedWorkColumns.NOTES_RESOLUTION]: {
        labels: [
          {
            a11yKey: 'completed_work.columns.resolution',
            a11yDefault: 'Resolution',
          },
        ],
      },
    },
  },
};

// Explicitly define columns that should not be shown in any user-selection
// scenarios (i.e. - report widget configuration).
export const completedWorkOmittedCols = [
  CompletedWorkColumns.GROUP_SELECTED,
  CompletedWorkColumns.SELECTED,
  CompletedWorkColumns.TASK_SR_STATUS,
  CompletedWorkColumns.TASK_LINKED,
  CompletedWorkColumns.STATUS,
  CompletedWorkColumns.NOTES_BOTH,
];

export const completedWorkCustomColConfigs = [CompletedWorkColumns.NOTES_LATEST_NOTE];

// Default order and visibility configuration for completed work columns
// NOTE: For state selection, EVERY column must have a position and visibility default!
export const completedWorkDefaultCols = [
  {
    id: CompletedWorkColumns.GROUP_SELECTED,
    cols: [
      {
        id: CompletedWorkColumns.SELECTED,
        visible: true,
      },
    ],
  },
  {
    id: CompletedWorkColumns.GROUP_ASSET_DETAILS,
    cols: [
      {
        id: CompletedWorkColumns.ASSET_NAME,
        visible: true,
      },
      {
        id: CompletedWorkColumns.ASSET_STATE,
        visible: true,
      },
      {
        id: CompletedWorkColumns.ASSET_SITE,
        visible: false,
      },
    ],
  },
  {
    id: CompletedWorkColumns.GROUP_TASK_DETAILS,
    cols: [
      {
        id: CompletedWorkColumns.TASK_TITLE,
        visible: true,
      },
      {
        id: CompletedWorkColumns.TASK_PRIORITY,
        visible: true,
      },
      {
        id: CompletedWorkColumns.TASK_ASSIGNED_TECHS,
        visible: true,
      },
      {
        id: CompletedWorkColumns.TASK_TYPE,
        visible: false,
      },
      {
        id: CompletedWorkColumns.TASK_STATUS,
        visible: false,
      },
      {
        id: CompletedWorkColumns.TASK_DESCRIPTION,
        visible: false,
      },
      {
        id: CompletedWorkColumns.TASK_LINKED,
        visible: false,
      },
      {
        id: CompletedWorkColumns.TASK_COMPONENT,
        visible: false,
      },
      {
        id: CompletedWorkColumns.TASK_SR_NUMBER,
        visible: false,
      },
      {
        id: CompletedWorkColumns.TASK_SR_STATUS,
        visible: false,
      },
    ],
  },
  {
    id: CompletedWorkColumns.GROUP_ESTIMATES,
    cols: [
      {
        id: CompletedWorkColumns.ESTIMATES_NUM_TECHS,
        visible: false,
      },
      {
        id: CompletedWorkColumns.ESTIMATES_DURATION,
        visible: false,
      },
      {
        id: CompletedWorkColumns.ESTIMATES_LABOR_HOURS,
        visible: false,
      },
    ],
  },
  {
    id: CompletedWorkColumns.GROUP_DATES,
    cols: [
      {
        id: CompletedWorkColumns.DATES_CREATED,
        visible: false,
      },
      {
        id: CompletedWorkColumns.DATES_ELIGIBLE_START,
        visible: false,
      },
      {
        id: CompletedWorkColumns.DATES_SCHEDULED,
        visible: false,
      },
      {
        id: CompletedWorkColumns.DATES_DUE,
        visible: false,
      },
      {
        id: CompletedWorkColumns.DATES_COMPLETED,
        visible: false,
      },
      {
        id: CompletedWorkColumns.SCHEDULED_END_DATE,
        visible: false,
      },
    ],
  },
  {
    id: CompletedWorkColumns.GROUP_PARTS,
    cols: [
      {
        id: CompletedWorkColumns.PARTS_EXPECTED,
        visible: false,
      },
      {
        id: CompletedWorkColumns.PARTS_CONSUMED,
        visible: true,
      },
    ],
  },
  {
    id: CompletedWorkColumns.GROUP_NOTES,
    cols: [
      {
        id: CompletedWorkColumns.NOTES_LATEST_NOTE,
        visible: true,
      },
      {
        id: CompletedWorkColumns.NOTES_RESOLUTION,
        visible: false,
      },
      {
        id: CompletedWorkColumns.NOTES_INTERNAL,
        // Should not be counted against max column selections, as this is a preference setting for the Latest Note column and not a column itself
        excludeFromCount: true,
        visible: false,
      },
      {
        id: CompletedWorkColumns.NOTES_EXTERNAL,
        // Should not be counted against max column selections, as this is a preference setting for the Latest Note column and not a column itself
        excludeFromCount: true,
        visible: false,
      },
    ],
  },
];
